import './App.css';
import WebContent from './components/webComp/WebContent';
import Home from './pages/Home';
import "react-datepicker/dist/react-datepicker.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link
}
  from 'react-router-dom';
import ProviderDetails from './pages/provider/ProviderDetails';

function App() {
  return (
    <Router>
      <Routes>
        <Route path='/' element={<Home />} >
        <Route index element={<WebContent />} />
        <Route path='/provider-detail' element={<ProviderDetails />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
